var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleAuth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.8 6.907c-1.166-1.115-2.649-1.683-4.3-1.683-2.93 0-5.41 1.98-6.295 4.638A6.8 6.8 0 0 0 5.852 12c0 .742.128 1.463.353 2.137.885 2.66 3.365 4.639 6.295 4.639 1.514 0 2.802-.4 3.81-1.074a5.18 5.18 0 0 0 2.245-3.396H12.5V9.955h10.596c.132.736.204 1.503.204 2.3 0 3.427-1.227 6.31-3.355 8.27-1.861 1.718-4.408 2.725-7.445 2.725A11.245 11.245 0 0 1 1.25 12 11.246 11.246 0 0 1 12.5.75c3.032 0 5.579 1.115 7.527 2.93z",
  clipRule: "evenodd"
})));
export default SvgGoogleAuth;